var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 33,
    viewBox: "0 0 44 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500357 0C1.19245 0.109277 1.97848 0.342747 2.73422 0.728596C25.8023 8.59439 39.7855 24.0547 43.5004 31C36.5004 26 27.5004 24.5 21.0004 29C15.4696 32.829 8.50036 34 4.00036 31C-0.499642 28 -1.99964 22.5 4.00036 12C7.75129 5.43586 5.43638 2.1082 2.73422 0.728596C1.99882 0.477838 1.25419 0.234799 0.500357 0Z",
    fill: "#92131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconCurve);
export default __webpack_public_path__ + "static/media/close-icon-curve.1b106453b02be8f234a9b8385e7c6df2.svg";
export { ForwardRef as ReactComponent };